// extracted by mini-css-extract-plugin
export default {"container":"BlockContainer_container__2u7gC"};